import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { FREE_OF_CHARGE_CATEGORY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Table from '../../../common/Table';
import { FREE_OF_CHARGE_SUB_CATEGORY_COLUMN } from '../../../../config/columns';
import Alert from '../../../common/informative/Alert';
import { GENERIC_NO_DATA_MESSAGE } from '../../../../config/messages';
import FreeOfChargeCategoryToolbar from './FreeOfChargeCategoryToolbar';
import {
  clearFreeOfChargeCategory,
  getFreeOfChargeCategory,
} from '../../../../actions/sales/FreeOfChargeCategory';
import FreeOfChargeCategoryBasicInformationResouce from './resources/FreeOfChargeCategoryBasicInformationResouce';

export const FreeOfChargeCategory = ({
  breadcrumbs,
  dispatchClearDiscountCodeCategory,
  dispatchGetDiscountCodeCategory,
  match: {
    params: { id: freeOfChargeCategoryId },
  },
  loading,
  freeOfChargeCategory,
}) => {
  useLayoutEffect(() => {
    dispatchGetDiscountCodeCategory({ freeOfChargeCategoryId });

    return () => dispatchClearDiscountCodeCategory();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (freeOfChargeCategory.isEmpty())
    content = <NoDataResource returnPage={FREE_OF_CHARGE_CATEGORY_PATH} />;
  else {
    const freeOfChargeCategoryJson = freeOfChargeCategory.toJS();

    const tableSubCategory =
      freeOfChargeCategoryJson.freeOfChargeSubCategoryList !== null &&
      freeOfChargeCategoryJson.freeOfChargeSubCategoryList.length !== 0 ? (
        <Table
          columns={FREE_OF_CHARGE_SUB_CATEGORY_COLUMN}
          data={freeOfChargeCategoryJson.freeOfChargeSubCategoryList}
          showPagination={false}
          defaultPageSize={
            freeOfChargeCategoryJson.freeOfChargeSubCategoryList.length
          }
        />
      ) : (
        <Alert type="warning" message={GENERIC_NO_DATA_MESSAGE} />
      );
    content = (
      <>
        <div className="row mb-4">
          <div className="col-md-8">
            <h3>Información Básica</h3>
            <FreeOfChargeCategoryBasicInformationResouce
              freeOfChargeCategory={freeOfChargeCategoryJson}
            />
          </div>
        </div>
        <div className="mt-4">
          <h3>Subcategorías</h3>
          {tableSubCategory}
        </div>
      </>
    );

    toolbar = (
      <FreeOfChargeCategoryToolbar
        freeOfChargeCategoryId={freeOfChargeCategoryJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Categoría Para Servicio a Título Gratuito"
      content={content}
    />
  );
};

FreeOfChargeCategory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearDiscountCodeCategory: PropTypes.func.isRequired,
  dispatchGetDiscountCodeCategory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  freeOfChargeCategory: PropTypes.instanceOf(Immutable.Map).isRequired,
};

FreeOfChargeCategory.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDiscountCodeCategory: clearFreeOfChargeCategory,
  dispatchGetDiscountCodeCategory: getFreeOfChargeCategory,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría Para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_CATEGORY_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  freeOfChargeCategory: SalesUnit.FreeOfChargeCategory.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.FreeOfChargeCategory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FreeOfChargeCategory);
